export default "__VITE_ASSET__DtLdUP7O__"